import axios from "axios";
import headers from "./Header";

// const api = axios.create();
class UserService {
	getAllRoles() {
		return axios.get("/api/roles", {
			headers: headers(),
		})
	}
	getPMSERoles() {
		return axios.get("/api/roles-pmse", {
			headers: headers(),
		})
	}
	getSsoUserByUsername(username) {
		return axios.get("/search-by-username/" + username, {
			headers: headers(),
		});
	}
	getSsoUserDaerahByUsername(username) {
		return axios.get("/search-by-username-daerah/" + username, {
			headers: headers(),
		});
	}
	addUser(data) {
		return axios.post("/api/users/", data, {
			headers: headers(),
		});
	}
	addUserPmse(data) {
		return axios.post("/api/pmse-users/", data, {
			headers: headers(),
		});
	}
	blastSdiUserPassword(){
		return axios.get("/api/blast-user-sdi-registrations/", {
			headers: headers(),
		});
	}
	resendUserPassword(id){
		return axios.get("/api/resend-password/users/"+id, {
			headers: headers(),
		});
	}
	changeUserPassword(newPassword){
		return axios.put("/api/users/password", {password : newPassword} ,{
			headers: headers(),
		});
	}
	addSdiUser(data) {
		return axios.post("/api/sdi/users/", data, {
			headers: headers(),
		});
	}
	updateUser(id,data) {
		return axios.put("/api/users/"+id, data, {
			headers: headers(),
		});
	}
	updatePmseUser(id,data) {
		return axios.put("/api/pmse-users/"+id, data, {
			headers: headers(),
		});
	}
	deleteUserPmse(id) {
		return axios.delete("/api/pmse-users/" + id, {
			headers: headers(),
		});
	}
   updateSdiUser(id,data) {
		return axios.put("/api/sdi/users/"+id, data, {
			headers: headers(),
		});
	}
	deleteSdiRoleUser(id){
		return axios.delete("/api/sdi/users/"+id, {
			headers: headers(),
		});
	}

	getAllUser(page, name, sdiOrganizationId) {
		let url = "/api/users?size=10"
		url += page ? '&page='+page : "&page=0";
		if (name) {
			url = url + "&name=" + name;
		}
		if (sdiOrganizationId) {
			url = url + "&sdiOrganizationId=" + sdiOrganizationId;
		}
		return axios.get(url, {
			headers: headers(),
		});
	}

	getAllUserPMSE(page, name) {
		let url = "/api/users-pmse?roles=1018&roles=1019&roles=1020&roles=1021&roles=1022&roles=1023&roles=1024&roles=1025&size=10"
		url += page ? '&page='+page : "&page=0";
		if (name) {
			url = url + "&name=" + name;
		}
		return axios.get(url, {
			headers: headers(),
		});
	}
	getAllUserPMSEDaerah(page, name, idRegion) {
		let url = `/api/users-pmse-daerah?idRegion=${idRegion}&roles=1024&roles=1025&size=10`
		url += page ? '&page='+page : "&page=0";
		if (name) {
			url = url + "&name=" + name;
		}
		return axios.get(url, {
			headers: headers(),
		});
	}
	getAllUserBySdiOrganizationId(page, name, sdiOrganizationId) {
		let url = "/api/sdi/users?size=10&sdiOrganizationId=" + sdiOrganizationId;
		url += page ? '&page='+page : "&page=0";
		if (name) {
			url = url + "&name=" + name;
		}
		return axios.get(url, {
			headers: headers(),
		});
	}
}
export default new UserService();